'use strict';

var novicell = novicell || {};
novicell.backgroundVideo = novicell.backgroundVideo || function () {
    function init() {
        var fullWidthBannerVideo = document.querySelectorAll('.full-width-banner--video');
        if(fullWidthBannerVideo.length){

            for(var i = 0 ; i < fullWidthBannerVideo.length ; i++){
                var bgVideo = fullWidthBannerVideo[i].querySelector('.full-width-banner__bg-video');
                if(bgVideo != null && !isHidden(bgVideo)){

                    //var dataVideo = fullWidthBannerVideo[i].querySelectorAll('.full-width-banner__bg-video:visible .dataVideo');
                    //cl(dataVideo);
                    var jumbotron = fullWidthBannerVideo[i].querySelector('.jumbotron-video');
                    if(jumbotron==null){
                        buildVideo(fullWidthBannerVideo[i]);
                    }

                }
            }
        }
    }
    function isHidden(el){
        var style = window.getComputedStyle(el);
        return (style.display === 'none');
    }

    function buildVideo(fullWidthBannerVideo){
        var video = document.createElement('video');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.classList.add('full-width-banner__jumbotron-video');

        var videoData = fullWidthBannerVideo.querySelectorAll('.full-width-banner__data-video');
        for(var i = 0 ; i < videoData.length ; i++){
            var dataSrc = videoData[i].getAttribute('data-src');
            var dataType = videoData[i].getAttribute('data-type');

            var videoType = document.createElement('source');
            videoType.setAttribute('src', dataSrc);
            videoType.setAttribute('type', dataType);
            video.appendChild(videoType);
        }
        var bgVideoElem = fullWidthBannerVideo.querySelector('.full-width-banner__bg-video');
        if(bgVideoElem !== null){
            bgVideoElem.appendChild(video);
        }
    }
    return {
        init:init
    };
}();
